var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.362 67.076c8.4 2.251 13.386 10.886 11.135 19.287-2.25 8.4-10.886 13.386-19.286 11.135-8.4-2.251-13.386-10.886-11.135-19.287 2.25-8.4 10.885-13.386 19.286-11.135zM74.05 54.066a6.637 6.637 0 01-9.052-2.481l-7.713-13.534a6.637 6.637 0 012.481-9.053L73.3 21.287a6.637 6.637 0 019.053 2.48l7.712 13.535a6.637 6.637 0 01-2.48 9.052L74.05 54.065z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.745 70.365a6.028 6.028 0 002.207-8.234l-3.014-5.22 5.22-3.014a6.028 6.028 0 00-6.028-10.441l-5.22 3.014-3.014-5.22a6.028 6.028 0 00-10.441 6.027l3.014 5.22-5.22 3.015a6.028 6.028 0 006.027 10.44l5.22-3.013 3.015 5.22a6.028 6.028 0 008.234 2.206z",
    fill: "#565656"
  })));
}

export default SvgAvatarPlaceholder;